module.exports = __webpack_public_path__ + "static/media/icon_Q&A.becdd674.svg";